class PostAPI {
  static all() {
    let domains = []

    if (window.location.href.indexOf('localhost') > -1) {
      domains = this.domains('dev')
    } else if (window.location.href.indexOf('bureaubright') > -1) {
      domains = this.domains('staging')
    } else {
      domains = this.domains('production')
    }

    // fetch all urls and return promises
    return domains.map(domain => {
      const url = this.postsUrl(domain)

      return fetch(url).then(response => {
        if (!response.ok) {
          throw Error(`Request rejected with status ${response.status}`)
        }
        return response.json()
      })
    })
  }

  static postsUrl(domain) {
    return `${domain}/wp-json/wp/v2/project?orderby=date&order=desc`
  }

  static domains(env) {
    let urls = []

    switch (env) {
      case 'dev':
        urls = ['http://localhost:7200']
        break
      case 'staging':
        urls = [
          'https://utron.bureaubright.nl',
          'https://wesotronic.bureaubright.nl',
          'https://etbdenoord.bureaubright.nl'
        ]
        break
      case 'production':
        urls = [
          'https://utron.nl',
          'https://wesotronic.nl',
          'https://etbdenoord.nl'
        ]
        break
    }

    return urls
  }
}

export default PostAPI



// WEBPACK FOOTER //
// ./src/js/projectsnews/api/PostAPI.js